import BaseAPI from '../base'

// 行动纪录-预警规则
class WarningRulesService extends BaseAPI {
  /**
   * 新增规则-查询数据源列表 --- ok
   * @param {*} {
                    "pageNo":1,
                    "pageSize":50,
                    "keyword":""
                }
   */
  fetchSourceListData(data) {
    return this.post({
      url: '/warn/datasource/list',
      data,
    })
  }

  // 集团版新数据源接口
  fetchSourceListData4xNew(data) {
    return this.post({
      url: '/warn/datasource/listV2',
      data,
    })
  }

  fetchSourceListDataCEM(data) {
    return this.post({
      url: '/cem/warn/datasource/list',
      data,
    })
  }

  // 查询词典 --- ok
  fetchDictionary(data) {
    return this.post({
      url: '/warn/dictionary/simplified-list',
      data,
    })
  }

  // 新增规则
  fetchAddRules(data) {
    return this.post({
      url: '/warn/rule/add',
      data,
    })
  }

  // 复制
  fetchCopyRules(params) {
    return this.get({
      url: '/warn/rule/copy',
      params,
    })
  }
  // 删除
  fetchDeleteRules(params) {
    return this.get({
      url: '/warn/rule/del',
      params,
    })
  }
  // 详情
  fetchDetailRules(params) {
    return this.get({
      url: '/warn/rule/detail',
      params,
    })
  }
  // 禁用 --- ok
  fetchDisabledRules(params) {
    return this.get({
      url: '/warn/rule/disable',
      params,
    })
  }
  // 启用 --- ok
  fetchEnableRules(params) {
    return this.get({
      url: '/warn/rule/enable',
      params,
    })
  }
  // 列表 --- ok
  fetchRulesList(data) {
    return this.post({
      url: '/warn/rule/list',
      data,
    })
  }
  // 修改
  fetchUpdateRules(data) {
    return this.post({
      url: '/warn/rule/update',
      data,
    })
  }
  // 联系人列表
  fetchContactsList(params) {
    return this.get({
      url: '/warn/contacts/list',
      params,
    })
  }
  // 新增联系人
  fetchAddContacts(data) {
    return this.post({
      url: '/warn/contacts/add',
      data,
    })
  }
  // 预警记录详情
  fetchRecordDetailList(params) {
    return this.get({
      url: '/warn/record/detail',
      params,
    })
  }
  // 查询机器人数据
  fetchRobotList(params) {
    return this.get({
      url: '/warn/webhook/simplify-page-list',
      params,
    })
  }

  // 查询工单状态
  fetchOrderStatusList(data) {
    return this.post({
      url: '/work-order/list-by-attribute',
      data,
    })
  }

  fetchOrderStatusList_new(data) {
    return this.post({
      url: '/process/work-order/list-by-attribute',
      data,
    })
  }

  // 查询当前租户是否配置企业微信
  fetchIsQW(params) {
    return this.get({
      url: '/warn/wx/check',
      params,
    })
  }

  // 企业微信组织机构查询 -- 只有短信和工单才有组织
  fetchIsQWList(params) {
    return this.get({
      url: '/warn/department/list',
      params,
    })
  }

  // 微信公众号
  fetchAccountList(data) {
    return this.post({
      // url: '/warn/contacts/list-by-tenant',
      url: '/member/manager/app/user/w/list',
      data,
    })
  }
  // 报警记录已读
  recordIsShow(ids, channelSource) {
    return this.get({
      url: `/front/voice/click?recordIds=${ids}&channelSource=${channelSource}`,
    })
  }

  // 点评数据
  fetchReview(params) {
    return this.get({
      url: '/warn/comment/warn-list',
      params,
    })
  }
  // 查询酒店用户列表信息
  fetchHotelUsers(data) {
    return this.post({
      // url: '/cem/hotel/user/list',
      url: '/member/manager/app/user/h/list',
      data,
    })
  }
  // 查询邮箱号 --
  fetchEmailList(data) {
    return this.post({
      url: '/member/manager/app/user/h/list',
      data,
    })
  }

  // 获取新工单权限
  fetchOrderPermission(params) {
    return this.get({
      url: '/apollo/query-common-config?key=new-work-order-tenant',
      params,
    })
  }
  fetchVoiceQualityStatus(data) {
    return this.post({
      url: '/warn/record/error/voiceQualityStatus',
      data,
    })
  }
  fetchVoiceQualityList(params) {
    return this.get({
      url: '/warn/record/error/voiceQualityList',
      params,
    })
  }

  // 语音数据
  fetchVoice(params) {
    return this.get({
      url: '/warn/voice/warn-list',
      params,
    })
  }

  // rms 调价数据
  fetchRms(params) {
    return this.get({
      url: '/warn/rms/warn-list',
      params,
    })
  }

  // 获取启用新语音预警规则租户列表
  fetchVoiceTenantList() {
    return this.get({
      url: '/apollo/config?key=warn-tenant',
    })
  }

  // 住中预警
  fetchWarningWhiteList() {
    return this.get({
      url: '/apollo/config?key=warnLevel',
    })
  }

  // 获取启用新语音预警规则租户列表
  fetchVoiceBlackTenantList() {
    return this.get({
      url: '/apollo/config?key=warn-black',
    })
  }

  getRoleList(params) {
    return this.get({
      url: '/member/manager/app/roles',
      params,
    })
  }
}

export default new WarningRulesService()
